<template>
  <div class="content">
    <heads :back="true" :msg="pageTitle"></heads>
    <div v-if="showLoading">
      <!-- 遮罩等待 -->
      <loadingView v-show="showLoading" />
    </div>
    <div v-else class="b_cnt">
      <!-- 灰色 -->
      <div class="grayLine"></div>
      <!-- 列表 -->
      <div class="xiaomie" @click="wrongDone(1)">
        <p class="left">
          <!-- <span class="line"></span> -->
          <img class="err_icon" src="https://newoss.zhulong.com/forum/202402/29/10/100810xdnc6hqs0q4pintu.png" alt="">
          <span class="text">已消灭错题</span>
        </p>
        <p class="right">
          <span>{{ annihilate_err_sum || 0 }}</span>
          <van-icon name="arrow" size="18" style="margin-left: 4px" />
        </p>
      </div>
      <div class="grayLine"></div>
      <div class="xiaomie" @click="wrongDone(2)">
        <p class="left">
          <!-- <span class="line"></span> -->
          <img class="err_icon" src="https://newoss.zhulong.com/forum/202402/29/10/100810xdnc6hqs0q4pintu.png" alt="">
          <span class="text">我的错题</span>
        </p>
        <p class="right">
          <span>{{ my_error_num || 0 }}</span>
          <van-icon name="arrow" size="18" style="margin-left: 4px" />
        </p>
      </div>
      <div class="grayLine"></div>
    </div>

  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getReport, getErrExerciseNum } from '@/api/zkbproEdu.js'
import loadingView from '@/components/loadingView.vue'

export default {
  components: {
    loadingView
  },
  data() {
    return {
      showLoading: true,
      pageTitle: '错题练习',
      // 分类id
      category_id: '',
      category_name: '',
      // 通过分类获取课程，选择的课程id和名称
      combine_id: '',
      combine_name: '',
      // source_id
      source_id: '',
      source_type: '5',
      class_id: '',
      lesson_id: '',
      // 列表
      tableDatas: [],
      defaultTreeProps: {
        children: 'children',
        label: 'name'
      },
      // 已消灭错题数
      annihilate_err_sum: 0,
      // 我的错题
      my_error_num: 0
    }
  },
  created() {
    this.source_id = this.$route.query.source_id || ''
    this.class_id = this.$route.query.class_id || ''
    this.lesson_id = this.$route.query.lesson_id || ''
    this.changedCombine()
  },
  methods: {
    // 头部切换课程
    changedCombine() {
      // 我的错题
      this.getErrorNumber(11)
      // 消灭错题
      this.getErrorNumber(12)
      // 刷新页面所有请求
      // this.getMyWrongList()
    },
    // 获取错题列表
    getMyWrongList() {
      this.showLoading = true
      const params = {
        source_id: this.source_id,
        source_type: this.source_type
      }
      getReport(params).then(res => {
        this.showLoading = false
        if (res.errNo === 0) {
          const result = res.result || []
          this.tableDatas = result
        } else {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.showLoading = false
      })
    },
    // 获取错题个数
    getErrorNumber(type) {
      this.showLoading = true
      const info = {
        source_id: this.source_id,
        source_type: type
      }
      getErrExerciseNum(info).then(res => {
        if (res.errNo === 0) {
          const num = res.result.num || 0
          if (type == 11) {
            // 我的错题
            this.my_error_num = num ?? 0
          } else if (type == 12) {
            // 消灭错题
            this.annihilate_err_sum = num ?? 0
          }
        }
        this.showLoading = false
      }).catch(() => {
        this.showLoading = false
      })
    },
    // 去消灭错题
    wrongDone(val) {
      if (val == 1) {
        // 消灭的
        if (this.annihilate_err_sum > 0) {
          this.$router.push({
            path: '/exerciseMode',
            query: {
              source_id: this.source_id,
              source_type: 12,
              lesson_id: this.lesson_id,
              class_id: this.class_id
            }
          })
        } else {
          this.$toast('暂无已消灭错题~')
        }
      } else {
        // 我的
        if (this.my_error_num > 0) {
          this.$router.push({
            path: '/exerciseMode',
            query: {
              source_id: this.source_id,
              source_type: 11,
              lesson_id: this.lesson_id,
              class_id: this.class_id
            }
          })
        } else {
          this.$toast('暂无错题~')
        }
      }
    },
    // 统一点击方法
    handleNodeClick(data) {
    }
  }
}
</script>
<style lang="scss" scoped>
.content {

}
.b_cnt {
  margin-top: 0px;
}
.grayLine {
  width: 100%;
  height: 20px;
  background-color: #F8F8F8;
}
.list_box {

}

.myTree{
  width: 100%;
  .open_one{
    background-size: contain !important;
    background: url("~@/assets/1_up.png") center no-repeat;
  }
  .close_one{
    background: url("~@/assets/1_down.png") center no-repeat;
  }
  .open_two{
    background: url("~@/assets/2_up.png") center no-repeat;

  }
  .close_two{
    background: url("~@/assets/2_down.png") center no-repeat;
  }
  .span-ellipsis{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F9F9F9;
    padding: 20px 0;
    width: calc(100% - 50px);
    .div_3{
      margin-top: 20px;
      display: flex;
      align-items:center;
      justify-content: space-between;
      .div_4 {
        display:flex;
        align-items: center;
      }
      .sp_wrong{
        font-size: 24px;
        color: #EE2E2E;
        font-weight: 400;
        margin-right:  20px;
      }
      .p_btn_red_border{
        font-family: PingFangSC-Regular;
        display: inline-block;
        width: 70px;
        height: 36px;
        line-height: 36px;
        border: 1px solid rgba(238,46,46,1);
        border-radius: 18px;
        font-size: 22px;
        color: #EE2E2E;
        text-align: center;
        font-weight: 400;
        margin-right: 10px;
      }
      .p_btn_red_bg{
        font-family: PingFangSC-Regular;
        display: inline-block;
        width: 120px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background-image: linear-gradient(103deg, #FF6E42 0%, #EE2E2E 77%);
        border-radius: 18px;
        font-size: 22px;
        color: #FFFFFF;
        font-weight: 400;
        margin-right: 6px;
      }
    }

    .tree_sp_name{
      width: calc(100% - 20px);
      display: inline-block;
      margin-left: 20px;
      color: #333333;
    }
    .p_title_name{
      // word-break: break-all;
      // overflow: hidden;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      font-size: 30px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .font_size_1{
      font-weight: 600;
    }
    .font_size_2{
      overflow:hidden;
    }
  }
  /deep/.el-tree-node__content{
    padding-left: 0px !important;
    height: auto;
    min-height: 54px;
    height: auto;
  }
  ::v-deep .el-icon-folder {
    height: 40px;
    width: 40px;
    background-size: contain;
    margin-left: 2px;
    font-size: 24px;
  }
  ::v-deep .el-icon-folder:before {
    content: "替";
    font-size: 24px;
    visibility: hidden;
  }
  ::v-deep .el-icon-file {
    margin-top: 1px;
    height: 40px;
    width: 40px;
    margin-left: 2px;
    background-size: contain !important;
    background: url("~@/assets/3.png") center no-repeat;
    font-size: 16px;
  }
  ::v-deep .el-icon-file:before {
    content: "替";
    font-size: 24px;
    visibility: hidden;
  }
  ::v-deep .el-icon-tree {
    font-size: 24px;
    margin-left: 2px;
    width: 40px;
    height: 40px;
    background-size: contain;
  }
  ::v-deep .el-icon-tree:before {
    content: "替";
    font-size: 24px;
    visibility: hidden;
  }
  ::v-deep  .el-tree-node__content:hover, .el-upload-list__item:hover {
    background-color: white;
  }
}
.xiaomie {
  display: flex;
  height: 50px;
  padding: 20px 30px;
  align-items: center;
  justify-content: space-between;
  .left{
    display: flex;
    align-items: center;
    .line{
      display: inline-block;
      width: 4px;
      height: 32px;
      background: #EE2E2E;
      border-radius: 3px;
      margin-right: 20px;
    }
    .text{
      font-family: PingFangSC-Medium;
      font-size: 26px;
      color: #333333;
      font-weight: 600;
    }
  }
  .right {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999;
    display: flex;
    align-items: center;
    font-weight: 400;
  }
}
.err_icon {
  margin-right: 10px;
  width: 28px;
  height: 28px;
  display: block;
}
</style>
